import { Controller } from "@hotwired/stimulus"
import { get } from "@rails/request.js"

// Connects to data-controller="insurances--prefill-insurance"
export default class extends Controller {
  static targets = ["paymentPurpose"]

  prefill() {
    const workspaceId = document.body.getAttribute("data-params-workspace-id")
    const insurance_type = this.paymentPurposeTarget.selectedOptions[0].value

    get(`/${workspaceId}/insurances_prefill?type=${insurance_type}`, {
      responseKind: "turbo-stream"
    })
  }
}
